import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Coupons ")
const _hoisted_4 = { class: "flex flex-row space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create new")
const _hoisted_6 = {
  key: 0,
  class: "col-span-full w-full flex flex-col space-y-2 pb-6"
}
const _hoisted_7 = { class: "w-full grid mdlg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4" }
const _hoisted_8 = { class: "col-span-1 flex flex-col space-y-3" }
const _hoisted_9 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_11 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Code ")
const _hoisted_13 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Discount ")
const _hoisted_15 = { class: "col-span-1 flex flex-col space-y-3" }
const _hoisted_16 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Usage ")
const _hoisted_18 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Status ")
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "flex flex-col w-full space-y-1 items-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Created on ")
const _hoisted_23 = { class: "col-span-2 flex flex-col space-y-3 items-center justify-center" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_25 = {
  key: 1,
  class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4"
}
const _hoisted_26 = { class: "w-full h-[200px] bg-grey100 rounded-md flex flex-row items-center justify-center" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("No coupon created yet")
const _hoisted_28 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-4" }
const _hoisted_29 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Applied Coupons ")
const _hoisted_31 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_badge = _resolveComponent("roof-badge")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_roof_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateCoupon()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.Coupons.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Coupons, (coupon, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-span-1 py-3 px-4 gap-2 grid grid-cols-2 border-[1px] border-grey300 rounded-md"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_roof_normal_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(coupon.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_roof_normal_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(coupon.code), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_roof_normal_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(coupon.percentage_discount) + "% ", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_roof_normal_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(coupon.applied_coupons.length), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_roof_badge, {
                        color: coupon.status == 'active' ? 'green' : 'orange'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.capitalize(coupon.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_roof_normal_text, { customClass: '!font-bold' }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_roof_normal_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Logic.Common.fomartDate(coupon.created_at, 'MM D, YYYY')), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_roof_button, {
                    padding: 'py-1 px-4',
                    onClick: ($event: any) => (_ctx.showUpdateCoupon(coupon))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_roof_normal_text, { color: 'text-gray-700' }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ])
        ])),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Financials.AppliedCouponTableStructure,
          paginatedData: _ctx.AppliedCoupons,
          "table-date-source": _ctx.Logic.Financials.AppliedCouponsSource
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}